import i18n from '@/js/i18n';
import api from '@/services/api';
import session from '@/services/api/compte/session';
import store from '@/store';
import { processSalesforceClientMigrated } from '@/services/api/compte/profile';

import { playerPaymentProfileStatus } from '@/helpers/ProfileHelpers';
import { PageMapping } from '@/helpers/PageMappingHelpers';
import { arrInAppMobile, getProductSourceFromQueryParams } from '@/helpers/ProductSourceHelpers';
import { returnToHome } from '@/helpers/RouteHelpers';

export default {
  async sauvegarderProfessionCanafe() {
    const state = store.state.compte;
    const { clientMigrated } = store.state.dossier;

    if (clientMigrated === null) {
      await processSalesforceClientMigrated();
    }

    const data = {
      dossier: {
        clientMigrated: store.state.dossier.clientMigrated,
        versionDonnees: store.state.dossier.versionDonnees,
      },
      custUUID: sessionStorage.getItem('lq_client_uuid'),
      occupationId: state.choixProfession?.idProfession,
      sectorId: state.choixProfession?.secteurActivite,
      situationId: state.choixProfession?.idSituationProfessionnelle,
      canafeConsent: state.canafe || 'n',
    };
    await api
      .call('players/occupation', 'sauvegarderProfession', 'put', {
        data,
      })
      .then((response) => {
        console.log(response);
        if (response.data && response.data.status === 'ERROR') {
          if (response.data.msg === 'CONNEXION') {
            session.fermerSession();
            returnToHome();
          } else {
            throw { url: PageMapping.ERREUR_IDENTITE_PROFESSION.siteUrl };
          }
        } else if (response.data && response.data.status === 'SUCCESS') {
          store.dispatch('compte/reset');
          console.log('Profession success 1');
          // Nouvelle version données après sauvegarde profession
          if (response.data?.playerProfile) {
            const versionDonnees = response.data?.playerProfile?.versionDonnees;
            store.commit('dossier/SET_DOSSIER_VERSION_DONNEES', versionDonnees);
          }
          // Specs: https://lotoquebec.atlassian.net/browse/SWSPC-1536
          // Un client "joueur" qui vient de saisir Profession/Canafe sera redirigé vers Explorer Jeux
          if (
            !store.state.profile.profileDetails.status.includes(playerPaymentProfileStatus.GUEST)
          ) {
            store.commit('profile/RESET_PROFILE_DETAILS');
            // On stocke dans le store une propriété custom 'joueurException' qui servira à contrôler
            // l'accès à la page 'identite-legislation-federale' pour les joueurs sans profession
            store.commit('profile/SET_JOUEUR_EXCEPTION', true);

            console.log('Profession success 2');

            if (arrInAppMobile.includes(getProductSourceFromQueryParams())) {
              console.log('Profession success 3');
              throw { url: PageMapping.DEPOT.siteUrl };
            } else {
              console.log('Profession success 4');
              throw {
                url: PageMapping.IDENTITE_CONFIRMATION_JEUX.siteUrl,
              };
            }
          }
          console.log('Profession success 1 prime');
          // Attention: Bien conserver cette ligne car le throw ci-haut sort de la fonction
          store.commit('profile/RESET_PROFILE_DETAILS');
        }
      })
      .catch((error) => {
        // Logique permettant l'affichage de IDENTITE_CONFIRMATION_JEUX ci-haut
        if (error.url && error.url != PageMapping.ERREUR_GENERIQUE.siteUrl) {
          console.log('Profession catch error');
          throw { url: error.url };
        } else {
          console.log('Profession catch error else');
          throw { url: PageMapping.ERREUR_IDENTITE_PROFESSION.siteUrl };
        }
      });
  },

  async getListeProfessions(context) {
    const state = store.state.compte;
    const langue = i18n.locale;
    if (state.choixProfession.langue != langue || state.listeProfessions.length == 0) {
      await api
        .call('occupations', 'occupations')
        .then((response) => {
          if (response.data && response.data.status === 'ERROR' && response.data.msg === 'MSG01') {
            throw { url: PageMapping.ERREUR_GENERIQUE.siteUrl };
          }
          const listeProfessions = response.data.occupations.workerCategories;
          store.commit('compte/SET_LISTE_PROFESSIONS', listeProfessions);
          store.commit('compte/SET_LANGUE', langue);
          return response;
        })
        .catch(function (error) {
          console.error('Erreur getListeProfessions', error);
          if (error.url) {
            throw error;
          } else {
            throw { url: PageMapping.ERREUR_GENERIQUE.siteUrl };
          }
        });
    }
  },
};
